"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _excluded = ["unique"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var propTypes = {
  unique: _propTypes.string
};

var Facebook = function Facebook(_ref) {
  var _ref$unique = _ref.unique,
      unique = _ref$unique === void 0 ? "" : _ref$unique,
      props = _objectWithoutPropertiesLoose(_ref, _excluded);

  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/_react["default"].createElement("defs", {
    fill: "inherit"
  }), /*#__PURE__*/_react["default"].createElement("g", {
    fill: "inherit",
    fillRule: "evenodd",
    id: "glyphs/social/facebook-facebook" + unique,
    stroke: "none",
    strokeWidth: 1
  }, /*#__PURE__*/_react["default"].createElement("use", {
    fill: "inherit",
    id: "fill-1-facebook" + unique,
    xlinkHref: "#path-1-facebook" + unique
  }), /*#__PURE__*/_react["default"].createElement("g", {
    fill: "inherit",
    id: "colors/core/gunmetal-facebook" + unique
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M13.6654171,9.5001562 L17.4167448,9.5001562 L16.7644486,13.2502343 L13.6654171,13.2502343 L13.6654171,22 L9.91658857,22 L9.91658857,13.2502343 L7,13.2502343 L7,9.5001562 L9.91658857,9.5001562 L9.91658857,6.9996876 C9.91658857,4.24679788 11.975945,2 14.497657,2 L17.4167448,2 L17.4167448,5.7500781 L14.497657,5.7500781 C14.0365511,5.7500781 13.6654171,6.30615433 13.6654171,6.9996876 L13.6654171,9.5001562 Z",
    fill: "inherit",
    id: "path-1-facebook" + unique
  }))));
};

Facebook.propTypes = propTypes;
var _default = Facebook;
exports["default"] = _default;